import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage } from '../../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';
import ReactHtmlParser from 'react-html-parser';
import './Disclaimer.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class Disclaimer extends Component {

    render() { 
        return ( 
            <div className="showtix-section showtix-background__primary-3">
                <div className="container">
                    <div className="row mt-3 mb-4">
                        <div className="col-12 text-center">
                            <button
                                type="button"
                                className="showtix-button showtix-background__primary-1"
                                disabled={!this.props.isReadyToSubmit}
                                onClick={this.props.postUser}
                            >
                                <span>{strings.signUp}</span>
                            </button>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 col-sm-1"></div>

                        <div className="col-12 col-sm-10 showtix-disclaimer text-center">
                            {
                                strings.paragraphs.map((paragraph) => ReactHtmlParser(paragraph.content))
                            }
                        </div>

                        <div className="col-12 col-sm-1"></div>
                    </div>
                </div>
            </div>
        )
    }
}

Disclaimer.propTypes = {
    isReadyToSubmit: PropTypes.bool,
    postUser: PropTypes.func
}
 
export default Disclaimer;


// WEBPACK FOOTER //
// ./src/components/Registration/Disclaimer/Disclaimer.js